import { assignJob, getFreePopulation } from '../map/settlement';
import type { ModalActionHandler } from './modalActionTypes';
import { getSettlement } from './settlementActionUtils';

export const hireAssistantAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (settlement === null) {
        return false;
    }

    const freePop = getFreePopulation(settlement);
    if (freePop <= 0) return false;
    if (!assignJob(settlement, 'assistants')) return false;
    return true;
};
